import React from "react";
import { NavLink } from "react-router-dom";
import { Home, CalendarDays, Compass, Sparkles, User } from "lucide-react";
import { WHATSAPP_NUM, track } from "../api";

export const Logo = ({ className = "", sub = false }) => (
  <div className={className}>
    <div className="logo-mas leading-none">MAS</div>
    {sub && <div className="text-[0.6rem] tracking-[0.28em] uppercase text-gray-500 mt-1">Tricopigmentazione · Coworking Studio</div>}
  </div>
);

export function waLink(msg) {
  return `https://wa.me/${WHATSAPP_NUM}?text=${encodeURIComponent(msg)}`;
}

export const WhatsAppButton = ({ msg, label = "Informazioni su WhatsApp", testid = "whatsapp-btn", className = "" }) => (
  <a data-testid={testid} href={waLink(msg)} target="_blank" rel="noreferrer"
    onClick={() => track("whatsapp_clicked")}
    className={`btn-outline inline-flex items-center justify-center gap-2 ${className}`}>
    {label}
  </a>
);

const items = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/prenota", label: "Coworking", icon: CalendarDays },
  { to: "/tricopigmentazione", label: "Trico", icon: Sparkles },
  { to: "/flash-day", label: "Flash Day", icon: Compass },
  { to: "/profilo", label: "Area personale", icon: User },
];

export const BottomNav = () => (
  <nav data-testid="bottom-nav" className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-100" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
    <div className="max-w-2xl mx-auto grid grid-cols-5">
      {items.map((it) => (
        <NavLink key={it.to} to={it.to} end={it.end} data-testid={`nav-${it.label.toLowerCase()}`}
          className="flex flex-col items-center gap-1 py-2.5 text-[0.62rem] font-medium">
          {({ isActive }) => (
            <>
              <it.icon size={21} strokeWidth={1.6} color={isActive ? "#7C1FD6" : "#71717a"} />
              <span style={{ color: isActive ? "#7C1FD6" : "#71717a" }}>{it.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </div>
  </nav>
);

export const Page = ({ children, className = "" }) => (
  <div className={`max-w-2xl mx-auto px-5 pt-6 fade-up ${className}`} style={{ paddingBottom: "calc(9rem + env(safe-area-inset-bottom))" }}>{children}</div>
);

export const SectionTitle = ({ children, sub }) => (
  <div className="mb-4">
    <h2 className="serif text-2xl md:text-3xl tracking-tight">{children}</h2>
    {sub && <p className="text-sm text-gray-500 mt-1">{sub}</p>}
  </div>
);
